// ============================================================================
// CLEO'S SECRET — FAQItem
// File: src/components/marketing/FAQItem.jsx
//
// Flat (non-accordion) question/answer pair used in the Membership page's
// "Practical Considerations" section. Doc directive is "plain, clear, brief"
// register, so all answers stay visible without expand/collapse interaction.
//
// Props:
//   question  string     bolded question (renders as italic Cormorant H3)
//   answer    string|JSX answer body (renders as justified Cormorant bodyLg)
//   isLast    boolean    when true, suppresses the bottom hairline so the
//                        last item in a list doesn't double up with the
//                        section divider below it.
// ============================================================================

import React from 'react';
import { P, T } from '../../lib/design-tokens';

export default function FAQItem({ question, answer, isLast }) {
  return (
    <div style={{
      padding: 'clamp(28px, 2.8vw, 40px) 0',
      borderBottom: isLast ? 'none' : '1px solid ' + P.SAND3,
    }}>
      <h3 style={{
        ...T.contentH2,
        color: P.INK,
        marginBottom: 18,
      }}>{question}</h3>
      <p style={{
        ...T.bodyLg,
        color: P.TX,
        textAlign: 'justify',
        hyphens: 'auto',
      }}>{answer}</p>
    </div>
  );
}
